import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const ClientIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M3,15.95c-.34.34-.34.9,0,1.24s.9.34,1.24,0l1.04-1.04-1.24-1.24-1.04,1.04Z" />
  <path d="M3.21,14.08l-1.24-1.24-.21.21c-.34.34-.34.9,0,1.24s.9.34,1.24,0l.21-.21Z" />
  <path d="M5.9,17.19c-.34.34-.34.9,0,1.24s.9.34,1.24,0l.21-.21-1.24-1.24-.21.21Z" />
  <path d="M14.82.82c-.23-.23-.6-.23-.83,0l-1.46,1.46c-.96-.09-1.91.25-2.59.93l-5.07,5.07c-.23.23-.23.6,0,.83.23.23.6.23.83,0l2.63-2.63c.18-.18.44-.22.67-.11,1.12.53,2.46.3,3.33-.57.23-.23.6-.23.83,0,.17.17.21.42.13.63l4.6,4.6c.37-.93.54-1.94.45-2.95l1.49-1.46c.23-.23.23-.6,0-.83L14.82.82Z" />
  <path d="M12.41,7.2c-1.05.65-2.35.8-3.53.38l-2.35,2.35c-.69.69-1.8.69-2.49,0-.69-.69-.69-1.8,0-2.49l5.08-5.08c-.55-.09-1.11-.14-1.66-.09l-1.46-1.46c-.23-.23-.6-.23-.83,0L.17,5.79c-.23.23-.23.6,0,.83l1.49,1.46c-.19,1.93.48,3.8,1.86,5.17l5.86,5.84c.34.34.9.34,1.24,0,.34-.34.34-.9,0-1.24l-3.36-3.36c-.23-.23-.23-.6,0-.83.23-.23.6-.23.83,0l4.77,4.77c.34.34.9.34,1.24,0s.34-.9,0-1.24l-4.77-4.77c-.23-.23-.23-.6,0-.83h0c.23-.23.6-.23.83,0l5.59,5.59c.34.34.9.34,1.24,0,.34-.34.34-.9,0-1.24l-5.59-5.59c-.23-.23-.23-.6,0-.83h0c.23-.23.6-.23.83,0l4.77,4.77c.34.34.9.34,1.24,0s.34-.9,0-1.24l-5.84-5.84Z" />
 </svg>,
 "Client"
);
